import Vue from 'vue';
// eslint-disable-next-line
export const hotelsEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/hotels/hotelsEventBus.js